<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import {UrlUtil} from "../../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../../lib/Common/Http/HttpRequestUtil";
    import PortalView from "../../../../component/common/Portal/PortalView.svelte";
    import EditDialogView from "../../../../component/common/Dialog/EditDialogView.svelte";
    import LabelValueView from "../../../../component/common/Value/LabelValueView.svelte";
    import InputAreaView from "../../../../component/common/Form/InputAreaView.svelte";
    import {AppAccessTokenTable} from "../../../../lib/Table/AppAccessTokenTable";


    const dispatcher = createEventDispatcher();

    export let app;
    export let editData = null;

    let isLoading = false;

    onMount(() => {
    });

    function onShow() {

    }

    function save() {


        const url = UrlUtil.createApiUrl("app_access_token");

        isLoading = true;
        HttpRequestUtil.postRequest(url, editData, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];

            close();

            dispatcher('update');

        });
    }

    function close() {
        dispatcher('close');

    }

    function onDelete() {
        const url = UrlUtil.createApiUrl("app_access_token");

        isLoading = true;
        HttpRequestUtil.deleteRequest(url, editData, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];

            close();

            dispatcher('update');

        });
    }

</script>

<PortalView>
    <EditDialogView
            title="アプリアクセストークン編集"
            editData={editData}
            on:save={save}
            canDelete={true}
            on:delete={onDelete}
            on:show={onShow} on:cancel={close}>
        <div class="app-access-token-edit-dialog-content">
            <div>
                <LabelValueView label="アプリ名" value={app.name}/>
            </div>

            <div>
                <div class="row">
                    <InputAreaView label="名前">
                        <input type="text" bind:value={editData.name} placeholder="名前"/>
                    </InputAreaView>
                </div>
                <div class="row">
                    <InputAreaView label="タイプ">
                        <select bind:value={editData.type} required>
                            <option></option>
                            {#each Object.entries(AppAccessTokenTable.Type.map) as [id, name]}
                                <option value={Number(id)}>
                                    {name}
                                </option>
                            {/each}
                        </select>
                    </InputAreaView>

                </div>

                <div class="row">
                    <InputAreaView label="有効期限" tipsMessage="設定すると有効期限が過ぎるとトークンは無効になります">
                        <input type="datetime-local" bind:value={editData.expire_at} placeholder="名前"/>
                    </InputAreaView>
                </div>
            </div>

            <div>
                {#if editData.access_token != null}
                    <InputAreaView label="アクセストークン" tipsMessage="アクセストークンは変更できません">
                        { editData.access_token }
                    </InputAreaView>
                {:else}
                    <InputAreaView label="アクセストークン">
                        ※新規登録時に自動設定されます
                    </InputAreaView>
                {/if}
            </div>

        </div>

    </EditDialogView>
</PortalView>


<style lang="scss">
    .app-access-token-edit-dialog-content {


    }
</style>